var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComprehensiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2896_24481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.13401 4.13401 0 8 0H42C45.866 0 49 3.13401 49 7V41C49 44.866 45.866 48 42 48H8C4.13401 48 1 44.866 1 41V7Z",
    fill: "#FEF9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 33C17.45 33 16.9792 32.8042 16.5875 32.4125C16.1958 32.0208 16 31.55 16 31V17C16 16.45 16.1958 15.9792 16.5875 15.5875C16.9792 15.1958 17.45 15 18 15H22.2C22.4167 14.4 22.7792 13.9167 23.2875 13.55C23.7958 13.1833 24.3667 13 25 13C25.6333 13 26.2042 13.1833 26.7125 13.55C27.2208 13.9167 27.5833 14.4 27.8 15H32C32.55 15 33.0208 15.1958 33.4125 15.5875C33.8042 15.9792 34 16.45 34 17V31C34 31.55 33.8042 32.0208 33.4125 32.4125C33.0208 32.8042 32.55 33 32 33H18ZM20 29H27V27H20V29ZM20 25H30V23H20V25ZM20 21H30V19H20V21ZM25 16.25C25.2167 16.25 25.3958 16.1792 25.5375 16.0375C25.6792 15.8958 25.75 15.7167 25.75 15.5C25.75 15.2833 25.6792 15.1042 25.5375 14.9625C25.3958 14.8208 25.2167 14.75 25 14.75C24.7833 14.75 24.6042 14.8208 24.4625 14.9625C24.3208 15.1042 24.25 15.2833 24.25 15.5C24.25 15.7167 24.3208 15.8958 24.4625 16.0375C24.6042 16.1792 24.7833 16.25 25 16.25Z",
    fill: "#D8AD09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2896_24481",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2896_24481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2896_24481",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveIcon);
export default __webpack_public_path__ + "static/media/comprehensive-icon.3da096de0fdc83c66cd86e1a066bde64.svg";
export { ForwardRef as ReactComponent };